import { AxiosInstance } from 'axios';
import { Result } from 'types/CodegenResult';

type ExternalReportData = {
  playerId: string;
  eventId: string;
  reportType: string;
};

export class ExternalReportService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getExternalReportData = async () => {
    const response = await this.axiosInstance.get<Result<ExternalReportData>>(`/connect/reports/data`);

    if (response.status === 401 || response.status === 403) {
      const error = new Error('Unauthorized');
      (error as any).response = response;
      throw error;
    }

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }

    throw Error('Error getting external report data');
  };
}

export default ExternalReportService;
